import styled from "styled-components";
import {
  colors,
  spacings,
  borders,
  fontSizes,
  fontWeights,
} from '../../styles/theme'

interface QuillEditorContainerProps {
  block?: boolean;
  isError?: boolean;
}

export const QuillEditorContainer = styled.div<QuillEditorContainerProps>`
  position: relative;
  width: ${props => props.block ? '100%' : 'auto'};
  margin-bottom: 32px;

  .editor-label {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 15px;
    padding: 0px ${spacings.xs};
    font-size: ${fontSizes.sm};
    color: ${colors.neutral_darkest};
    font-weight: ${fontWeights.w700};
    background: ${colors.white};
    transform: translateY(-50%);
    transition: all 0.3s ease-out;
    z-index: 1;
  }

  .error-message {
    color: ${colors.secondary_four};
    font-size: ${fontSizes.sl};
    margin-top: ${spacings.xs};
    display: block;
  }

  /* Estilos customizados para o Quill */
  .quill {
    border: ${props => props.isError ? `${borders.xs} solid ${colors.secondary_four}` : `${borders.xs} solid ${colors.neutral_medium}`};
    border-radius: ${borders.lg};
    overflow: hidden;
    transition: all 0.3s ease-out;
  }

  /* Quando o editor tem conteúdo ou está focado, move o label para cima e muda a borda */
  .quill:focus-within ~ .editor-label,
  .quill.has-content ~ .editor-label {
    top: 0;
    font-size: ${fontSizes.sl};
    color: ${colors.neutral_darkest};
  }

  .quill {
    border: ${props => props.isError ? `${borders.xs} solid ${colors.secondary_four}` : `${borders.xs} solid ${colors.primary}`};
  }

  .ql-toolbar {
    border: none;
    border-bottom: ${borders.xs} solid ${colors.neutral_medium};
    background: ${colors.neutral_light};
    padding: ${spacings.sm} ${spacings.md};
  }

  .ql-container {
    border: none;
    font-family: 'DM Sans', sans-serif;
    font-size: ${fontSizes.sm};
    color: ${colors.neutral_darkest};
  }

  .ql-editor {
    min-height: 160px;
    padding: ${spacings.md};
    line-height: 1.5;
  }

  .ql-editor.ql-blank::before {
    color: ${colors.neutral_darker};
    font-style: italic;
  }

  /* Estilos para botões da toolbar */
  .ql-toolbar button {
    color: ${colors.neutral_darkest};
  }

  .ql-toolbar button:hover {
    color: ${colors.primary};
  }

  .ql-toolbar button.ql-active {
    color: ${colors.primary};
  }

  /* Estilos para dropdowns */
  .ql-toolbar .ql-picker {
    color: ${colors.neutral_darkest};
  }

  .ql-toolbar .ql-picker-options {
    background: ${colors.white};
    border: ${borders.xs} solid ${colors.neutral_medium};
    border-radius: ${borders.sm};
  }
`;


